import React from 'react'

// Lazy loading
import loadable from '@loadable/component'

interface GalleryShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Gallery
  location?: any
}

interface PostProps {
  [key: string]: any
}

const GalleryShell: React.FC<GalleryShellProps> = ({
  fields,
  location = {},
}) => {
  const types: PostProps = {
    default: loadable(() => import('components/flex/Gallery/GalleryDefault')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default GalleryShell
